import { gql } from '@apollo/client';

// variables: { options: { limit: 10, page:1 } }
export const GET_LEADERBOARDS = gql`
query Leaderboards($options: Leaderboard_OptionsInput) {
  leaderboards(options: $options) {
    edges {
      node {
        leaderboardId
        leaderboardTypeId
        name
        timezone
        description
        granularity
        isPublished
        isFeatured
        startAt
        endAt
        weight
        locales {
          code
          name
          description
        }
      }
    }
    pagination
    totalCount
  }
}
`;
//variables:{leaderboardId:1a820426-a831-4a8a-9782-d943dddeaeca}
export const GET_LEADERBOARD = gql`
query Leaderboard($leaderboardId: UUID!) {
  leaderboard(leaderboardID: $leaderboardId) {
    node {
      leaderboardId
      leaderboardTypeId
      timezone
      name
      description
      granularity
      isFeatured
      isPublished
      weight
      startAt
      endAt
      locales {
        code
        name
        description
      }
    }
  }
}`;

// variables: {input: {leaderboardTypeId: 067c0f98-8874-4b5f-bdee-c6326ed36051, name: test GQL, description: ,granularity: ALL, isPublished: false, isFeatured: false, weight: 0, locales: [{code: en-US, name: test GQL - en-US, description: null}, {code: fr-FR, name: test GQL - fr-FR, description: null}]}}}'
export const CREATE_LEADERBOARD = gql`
mutation CreateLeaderboard($input: CreateLeaderboardInput!) {
  createLeaderboard(input: $input) {
    leaderboardId
    name
    timezone
    description
    leaderboardTypeId
    granularity
    isFeatured
    isPublished
    locales {
      code
      description
      name
    }
    weight
    startAt
    endAt
  }
}`;

//variables: {input: {leaderboardId: 1a820426-a831-4a8a-9782-d943dddeaeca, leaderboardTypeId: 067c0f98-8874-4b5f-bdee-c6326ed36051, name: test GQL ed, description: ,granularity: ALL, isPublished: false, isFeatured: false, weight: 0, locales: [{code: en-US, name: test GQL ed - en-US, description: null}, {code: fr-FR, name: test GQL ed - fr-FR, description: null}]}}}'
export const PATCH_LEADERBOARD = gql`
mutation PatchLeaderboard($input: PatchLeaderboardInput!) {
  patchLeaderboard(input: $input) {
    leaderboardId
    leaderboardTypeId
    name
    timezone
    description
    granularity
    isFeatured
    isPublished
    weight
    startAt
    endAt
    locales {
      code
      name
      description
    }
  }
}`;

// variables: {input: {leaderboardId: 1a820426-a831-4a8a-9782-d943dddeaeca}}}'
export const DELETE_LEADERBOARD = gql`
mutation DeleteLeaderboard($input: DeleteLeaderboardInput!) {
  deleteLeaderboard(input: $input) {
    affectedRows
  }
}`;

// variables: {input: {leaderboardId: 1a820426-a831-4a8a-9782-d943dddeaeca, name: test audience, description: null, locales: [{code: en-US, name: test audience - en-US, description: null}, {code: fr-FR, name: test audience - fr-FR, description: null}]}}}'
export const CREATE_LEADERBOARD_AUDIENCE = gql`
mutation CreateLeaderboardAudience($input: CreateLeaderboardAudienceInput!) {
  createLeaderboardAudience(input: $input) {
    leaderboardId
    leaderboardAudienceId
    name
    description
    locales {
      code
      description
      name
    }
  }
}`;

// variables: {leaderboardId: 1a820426-a831-4a8a-9782-d943dddeaeca}}'
export const GET_LEADERBOARD_AUDIENCES = gql`
query LeaderboardAudiences($leaderboardId: UUID!) {
  leaderboardAudiences(leaderboardID: $leaderboardId) {
    totalCount
    pagination
    edges {
      node {
        leaderboardAudienceId
        leaderboardId
        name
        description
        locales {
          code
          name
          description
        }
        brandIds
        categoryIds
        companyRelationshipIds
        employeeLocaleIds
        learningProfileIds
        localeIds
        productIds
        resourceIds
        segmentIds
        tagIds
      }
    }
  }
}`;

export const GET_LEADERBOARD_AUDIENCES_MINIMUM = gql`
query LeaderboardAudiences($leaderboardId: UUID!) {
  leaderboardAudiences(leaderboardID: $leaderboardId) {
    totalCount
    pagination
    edges {
      node {
        leaderboardAudienceId
        leaderboardId
        name
        description
      }
    }
  }
}`;

export const GET_LEADERBOARD_AUDIENCE = gql`
query LeaderboardAudience($leaderboardId: UUID!, $leaderboardAudienceId: UUID!) {
  leaderboardAudience(leaderboardID: $leaderboardId, leaderboardAudienceID: $leaderboardAudienceId) {
    node {
      leaderboardAudienceId
      leaderboardId
      name
      description
      locales {
        code
        name
        description
      }
      brandIds
      categoryIds
      companyRelationshipIds
      employeeLocaleIds
      learningProfileIds
      localeIds
      productIds
      resourceIds
      segmentIds
      tagIds
    }
  }
}
`;




// variables: {input: {leaderboardAudienceId: 762ebafa-1411-4d8f-b333-4c1424379bad, leaderboardId: 1a820426-a831-4a8a-9782-d943dddeaeca, name: test audience ed, description: null, locales: [{code: en-US, name: test audience ed - en-US, description: null}, {code: fr-FR, name: test audience ed - fr-FR, description: null}]}}}'
export const PATCH_LEADERBOARD_AUDIENCE = gql`
mutation PatchLeaderboardAudience($input: PatchLeaderboardAudienceInput!) {
  patchLeaderboardAudience(input: $input) {
    leaderboardAudienceId
    leaderboardId
    name
    description
    locales {
      code
      name
      description
    }
  }
}`;

// variables: {input: {leaderboardAudienceId: c6895f22-070c-4fd1-b817-8cd4ff4dd9df, leaderboardId: 93b71129-3294-4233-b5ba-3bfd0ec51283}}}'
export const DELETE_LEADERBOARD_AUDIENCE = gql`
mutation DeleteLeaderboardAudience($input: DeleteLeaderboardAudienceInput!) {
  deleteLeaderboardAudience(input: $input) {
    affectedRows
  }
}`;



export const GET_LEADERBOARD_TYPES = gql`
query LeaderboardTypes {
  leaderboardTypes {
    edges {
      node {
        leaderboardTypeId
        label
        name
        description
        createdAt
        updatedAt
      }
    }
  }
}`;
